const basePath = () => {
  if (process.env.VUE_APP_API_URL) return process.env.VUE_APP_API_URL;

  const subfolder = process.env.VUE_APP_API_SUBFOLDER || "";
  return `${window.location.protocol}//${window.location.host}${subfolder}`;
};

export default basePath;
